@let mobile = (screen.screenSize$ | async)?.isMobile; @let user = auth.user$ |
async; @let avatar = threadView ? friend : user;
<header
  class="relative shrink-0 border-b px-2"
  [class]="
    mobile
      ? 'border-borders-dark dark:border-black-dark-light'
      : 'border-borders-light dark:border-borders-darker'
  "
  [class.shadow-md]="scrolled"
>
  <div
    class="flex h-[56px] items-center gap-1"
    [class]="mobile ? '' : 'pr-[44px]'"
  >
    @if (mobile || threadView) {
    <button
      type="button"
      class="flex h-[36px] w-[36px] shrink-0 items-center justify-center rounded-full bg-black/50 hover:bg-black/65 dark:hover:bg-white/20"
      [class]="mobile ? '-ml-[4px]' : ''"
      [attr.aria-label]="
        (threadView ? 'DISCUSSIONS.BACK' : 'CLOSE_MODAL') | translate
      "
      (click)="back.emit()"
    >
      <span
        aria-hidden="true"
        class="block w-[20px] h-[20px] rotate-180 bg-white mask-[url(/assets/images/icons/arrow-right.svg)] mask-size-[20px_20px]"
      ></span>
    </button>
    }
    <span class="relative block w-[32px] h-[32px] shrink-0">
      @if (avatar) {<app-user-avatar
        [name]="avatar.username"
        [firstname]="threadView ? undefined : user?.firstname"
        [lastname]="threadView ? undefined : user?.lastname"
        [picture]="avatar.picture"
        [size]="32"
        [online]="threadView ? friendOnline : !!(socket.ready$ | async)"
        [onlineLabel]="
          threadView ? 'DISCUSSIONS.PRESENT' : 'DISCUSSIONS.SELF_ONLINE'
        "
      ></app-user-avatar
      >} @else {<span
        class="block w-full h-full rounded-full bg-whiteshade dark:bg-blacker"
      ></span
      >}
    </span>
    <div class="min-w-0 flex-1">
      <h2
        #titleElement
        id="recommendation-thread-title"
        tabindex="-1"
        class="m-0! text-base! leading-tight! truncate"
      >
        {{ title }}
      </h2>
      @if (threadView) {
      <p class="m-0! text-xs truncate min-h-[14px]" [title]="subtitle">
        {{ subtitle }}
      </p>
      }
    </div>
  </div>
  @if (threadView) {
  <div class="flex h-[28px] -translate-y-0.5 items-center gap-1 pl-[44px]">
    <button
      type="button"
      class="relative shrink-0 rounded-lg border border-borders-light dark:border-borders-darker px-1 py-0.5 text-xs aria-busy:cursor-wait!"
      [disabled]="detailsDisabled || detailsLoading"
      [attr.aria-busy]="detailsLoading"
      [attr.aria-label]="
        (detailsLoading ? 'DISCUSSIONS.LOADING' : 'DISCUSSIONS.DETAILS')
          | translate
      "
      (click)="details.emit()"
    >
      <span [class.invisible]="detailsLoading" aria-hidden="true">
        {{ "DISCUSSIONS.DETAILS" | translate }}
      </span>
      @if (detailsLoading) {
      <span
        class="absolute inset-0 flex items-center justify-center"
        aria-hidden="true"
      >
        <img
          src="/assets/images/loading.svg"
          alt=""
          class="block h-2 w-2 shrink-0"
        />
      </span>
      }
    </button>
    <ng-content></ng-content>
  </div>
  } @if (!mobile) {
  <button
    type="button"
    class="absolute top-[10px] right-2 flex h-[36px] w-[36px] items-center justify-center"
    [attr.aria-label]="'CLOSE_MODAL' | translate"
    (click)="closePanel.emit()"
  >
    <span
      aria-hidden="true"
      class="block w-[20px] h-[20px] bg-current mask-[url(/assets/images/icons/close.svg)] mask-contain mask-no-repeat"
    ></span>
  </button>
  }
</header>
